<template>
  <div>
    <el-table
      :data="images"
    >
      <el-table-column
        prop="ingredient"
        label="Kép"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-tooltip
            placement="top"
            popper-class="permission-info-tooltip">
            <div slot="content">
              <el-image
                style="max-width: 300px; max-height: 300px"
                :src="scope.row.image.full"
              />
            </div>
            <el-image
              style="width: 50px; height: 50px; cursor: pointer;"
              :src="scope.row.image.full"
              fit="contain"
              @click="openImage(scope.row.image.full)"
            />
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        prop="is_primary"
        label="Elsődleges"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{ scope.row.is_primary ? 'Igen' : 'Nem' }}
        </template>
      </el-table-column>
      <el-table-column
        prop="description"
        label="Leírás"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{ scope.row.description || '-' }}
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label=""
        width="130"
        style="text-align: right;"
      >
        <template
          slot-scope="scope"
        >
          <actions
            :image="scope.row"
            @update="onUpdate"
            @delete="onDelete"
          />
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      :visible="showDialog"
      :title="imageFormType === 'add' ? 'Új kép' : 'Kép módosítás'"
      append-to-body
      :close-on-click-modal="false"
      width="450px"
      @close="onClose"
      :key="dialogKey"
    >
      <image-form
        ref="imageForm"
        :defaultImage="selectedImage"
        :formType="imageFormType"
        :images="images"
      />
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="onClose">
          Mégse
        </el-button>
        <el-button
          type="primary"
          @click="storeImages"
        >
          {{ imageFormType === 'add' ? 'Hozzáadás' : 'Módosítás' }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import Actions from './Actions';
  import ImageForm from './Form';

  export default {
    components: { Actions, ImageForm },
    props: ['images', 'showDialog', 'imageFormType'],
    data() {
      return {
        dialogKey: 0,
        selectedImage: {},
      };
    },
    methods: {
      openImage(path) {
        window.open(path);
      },
      onClose() {
        this.$refs.imageForm.$refs.imageForm.resetFields();
        this.$refs.imageForm.image = {
          image: {}
        };
        this.$emit('closeDialog');
      },
      onCreate() {
        this.imageFormType = 'add';
        this.dialogKey++;
        this.$emit('openCreateDialog');
      },
      onUpdate(image) {
        this.selectedImage = Object.assign({}, image);
        this.$emit('openUpdateDialog');
      },
      onDelete(image) {
        const images = this.images.filter(a => ((a.id && a.id !== image.id) || a.key !== image.key));
        this.$emit('change', images);
        this.$emit('imageDelete', image);
      },
      isPrimaryImage() {
        let primary = this.images.find(i => i.is_primary);
        if(primary) {
          return true;
        }
        return false;
      },
      async storeImages() {
        const image = Object.assign({}, this.$refs.imageForm.image);
        if((this.imageFormType === 'add' && image.image.file) || this.imageFormType === 'update') {
          if ((image.is_primary && this.imageFormType === 'add' && !this.isPrimaryImage()) || ((this.imageFormType === 'update' && image.is_primary && this.selectedImage.is_primary) || (this.imageFormType === 'update' && image.is_primary && !this.selectedImage.is_primary && !this.isPrimaryImage())) || !image.is_primary) {
            this.$refs['imageForm'].$refs['imageForm'].validate(valid => {
              if (valid) {
                if (this.imageFormType === 'add') {
                  this.$emit('add', image);
                } else {
                  const images = this.images.map(a => {
                    if ((a.id && a.id === image.id) || (a.key && a.key === image.key)) {
                      return image;
                    } else {
                      return a;
                    }
                  });
                  this.$emit('change', images);
                }
                this.$emit('closeDialog');
              }
            });
          } else {
            this.$messageWrapper.warning('Csak egy elsődleges kép lehet');
          }
        } else {
          this.$messageWrapper.warning('Kép feltöltese kötelező');
        }
      },

    }
  };
</script>
